import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { FeaturedWork } from './components/FeaturedWork';
import { About } from './components/About';
import { Footer } from './components/Footer';
import { CaseStudy } from './components/CaseStudy';
function Home() {
  return <>
      <Hero data-id="element-0" data-mp="2rkdvopi073ln" />
      <FeaturedWork data-id="element-1" data-mp="2rk47n7gir6il" />
      <About data-id="element-2" data-mp="2rlf8ayeo3y5h" />
    </>;
}

/**
 * Scrolls to the hash target after a route change so links like `/#work`
 * coming from a case study page land on the right section.
 */
function HashScroll() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const el = document.getElementById(hash.slice(1));
    if (!el) return;
    // Wait a frame so the route's content is mounted before measuring.
    const raf = requestAnimationFrame(() => {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
    return () => cancelAnimationFrame(raf);
  }, [pathname, hash]);
  return null;
}
export function App() {
  return <div className="min-h-screen bg-background text-foreground selection:bg-accent selection:text-white" data-id="element-3" data-mp="3ml13n8r6loj0">
      <HashScroll data-id="element-4" data-mp="3rbzmog3k10py" />
      <Nav data-id="element-5" data-mp="3rdkisa5iorpx" />
      <main data-id="element-6" data-mp="3rcswxr1q28cu">
        <Routes data-id="element-7" data-mp="3recf5n6xuth9">
          <Route path="/" element={<Home data-id="element-9" data-mp="6hovayao7c0" />} data-id="element-8" data-mp="5yk6vxnnffx" />
          <Route path="/work/:slug" element={<CaseStudy data-id="element-11" data-mp="82kl3wchwbg" />} data-id="element-10" data-mp="4wyzymxdckh" />
          <Route path="*" element={<CaseStudy data-id="element-13" data-mp="2zlv8x0aavbxp" />} data-id="element-12" data-mp="2zld0z6e9z99y" />
        </Routes>
      </main>
      <Footer data-id="element-14" data-mp="2zng0qi58cgrv" />
    </div>;
}